document.addEventListener('DOMContentLoaded', () => {
  const videoWrapper = document.querySelector('.custom-media-grid__video-wrapper');
  if (!videoWrapper) return;

  const video = videoWrapper.querySelector('.custom-media-grid__video');
  const playButton = videoWrapper.querySelector('.custom-media-grid__play-button');

  if (!video || !playButton) return;

  // Toggle play/pause on button click
  const togglePlayPause = () => {
    if (video.paused) {
      video.play();
      playButton.classList.add('is-playing');
    } else {
      video.pause();
      playButton.classList.remove('is-playing');
    }
  };

  playButton.addEventListener('click', (e) => {
    e.stopPropagation();
    togglePlayPause();
  });

  videoWrapper.addEventListener('click', () => {
    togglePlayPause();
  });

  // Intersection Observer to play video when it comes into view
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5 // trigger when at least 50% of the video is visible
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Video is in view
        if (video.paused) {
          // Play the video and update button state
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              playButton.classList.add('is-playing');
            }).catch((error) => {
              console.log('Autoplay was prevented', error);
            });
          }
        }
      } else {
        // Video is out of view
        if (!video.paused) {
          video.pause();
          playButton.classList.remove('is-playing');
        }
      }
    });
  }, observerOptions);

  observer.observe(videoWrapper);
});